module.exports = __webpack_public_path__ + "img/temple64_ua.b9c7de1d.webp";